import { SupportedLocales } from '../supportedLocales'

const isLocaleSupported = (
  locale: string,
  supportedLocales: SupportedLocales
) =>
  Object.values(supportedLocales).some(
    ({ value }) => value.toLowerCase() === locale.toLowerCase()
  )

export default isLocaleSupported
